import { Tooltip } from '@mui/material';
import styles from './VerifyCheckmark.module.css';

function VerifyCheckmark({ onClick }) {
    return (
        <Tooltip title="Mark as verified" placement="top">
            <button className={styles.checkmark} onClick={onClick} type="button" tabIndex={-1}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.3333 4L5.99999 11.3333L2.66666 8" stroke="#00BC7C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </Tooltip>
    );
}

export default VerifyCheckmark;
